<div class="flex h-[100dvh]">
  @if (isLoader()) {
    <div
    class="absolute top-0 right-0 bottom-0 left-0 z-10 bg-sky-50 opacity-60 backdrop-blur-2xl"
    ></div>
  }
  <div
  class="relative flex h-full min-h-full grow flex-col overflow-x-hidden overflow-y-auto "
  >

  @if (isLoader()) {
    <div class="sticky top-1/2 left-1/2 z-20 h-0 w-max -translate-x-1/2">
      <nx-spinner [size]="'large'" />
    </div>
  }
  @if(appType === AppType.Agent) {
    <app-header/>
  }
    <div #container class="container mx-auto mb-4 px-2 pt-4 sm:px-8">
      <div class="flex h-10 justify-between gap-4">
        <img src="logo-mondial.svg" alt="logo Mondial Assistance" />
        @if (isHeaderTitle()) {
          <h1
            class="santander-headline hidden !text-center text-2xl font-bold sm:block"
          >
            {{ "header.insurence" | translate }}
            <span class="whitespace-nowrap"
              >"{{
                "header." + policyStore.currentPolicyType | translate
              }}"</span
            >
          </h1>
        }
        <img src="logo-santander.svg" alt="logo Santander Consumer Bank" />
      </div>
      @if (isHeaderTitle()) {
        <h1
          class="santander-headline mt-4 block !text-center text-2xl font-bold sm:hidden"
        >
          {{ "header.insurence" | translate }}
          <span class="whitespace-nowrap"
            >"{{ "header." + policyStore.currentPolicyType | translate }}"</span
          >
        </h1>
      }

      <div class="mt-12">
        @defer {
          <ng-content />
        } @placeholder (minimum 500ms) {
          <div
            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          >
            <nx-spinner [size]="'large'" />
          </div>
        }
      </div>
    </div>
    <div class="sticky bottom-0 -mx-2 mt-auto sm:-mx-8 px-2 pt-4 sm:px-8">
      <div
        class="z-[1050] bg-white px-8  shadow-[0px_0px_8px_rgba(0,-2,16,0.25)]"
      >
        <app-navigation-buttons />
      </div>
      <app-message
        class="absolute bottom-32 left-1/2 z-[1001] -translate-x-1/2 sm:bottom-20"
        [ngStyle]="{ 'width.px': containerWidth() }"
      />
    </div>
  </div>
  @if (policyStore.currentPolicyType$() && appType !== AppType.Agent) {
    <img
      [src]="policyStore.currentPolicyType$() + '-photo.webp'"
      class="z-20 hidden h-full object-cover object-top 2xl:block"
    />
  }
</div>
